import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-dialogo-resp-exenciones',
  templateUrl: './dialogo-resp-exenciones.component.html',
  styleUrls: ['./dialogo-resp-exenciones.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoRespExencionesComponent implements OnInit {

  constructor(
  		public dialogRef: MatDialogRef<DialogoRespExencionesComponent>, 
          @Inject(MAT_DIALOG_DATA) private data: any
      ) { 

    	}

    ngOnInit() {
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// D:/arquitectura/workspace/Form300/Diligenciamiento_IngresoIva300_1.0.0/Diligenciamiento_IngresoIva300_1.0.0/Angular/Iva300Ingreso/src/app/components/dialogo-respuesta/dialogo-resp-exenciones.component.ts